import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Taxonomy } from 'bookraw/shared/models/taxonomy.model';
import { Observable } from 'rxjs';
import { PaginationData } from 'bookraw/shared/models/pagination-data';

@Injectable()
export class TaxonomiesService extends ListService<Taxonomy> {

  url: string = '/api/admin/taxonomies';

  getForSelect(text: string): Observable<PaginationData<Taxonomy>> {
    this.setQueryParam('filters[title]', text);
    return this.get();
  }
}
